export const LAMBDATEST_PAUSE_LOADING = "LAMBDATEST_PAUSE_LOADING";
export const LAMBDATEST_PAUSE_SUCCESS = "LAMBDATEST_PAUSE_SUCCESS";
export const LAMBDATEST_PAUSE_FAILED = "LAMBDATEST_PAUSE_FAILED";
export const LAMBDATEST_PAUSE_CLEAR = "LAMBDATEST_PAUSE_CLEAR";
